import type { ThHTMLAttributes } from 'react';

import { cn } from '../../lib/utils';

interface TableHeaderCellProps extends ThHTMLAttributes<HTMLTableCellElement> {
  numeric?: boolean;
}

export function TableHeaderCell({ className, numeric = false, ...props }: TableHeaderCellProps) {
  return (
    <th
      className={cn(
        'px-3 py-2 text-type-card-label uppercase text-text-muted',
        numeric && 'text-right tabular-nums',
        className,
      )}
      {...props}
    />
  );
}
